import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { BusyCursor } from 'src/app/shared/busycursor/busycursor';
import { ThemeService } from 'src/app/theme/theme.factory';
import { Router, Event, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { GlobalExceptionHandlerPopupComponent } from 'src/app/shared/popups/globalexceptionhandler/globalexceptionhandler-popup.component';
import { ListFactory } from 'src/app/shared/caches/list.factory';
import { UnsavedObjectsPopupComponent } from 'src/app/shared/popups/unsaved/unsavedobjects-popup.component';
import { StateUrlCache } from '../shared/caches/stateurl.cache';

/**
 * Application root component
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements AfterViewInit {
  @ViewChild('globalExceptionHandlerPopupId') globalExceptionHandlerPopupId: any;
  @ViewChild('unsavedObjectsPopupId') unsavedObjectsPopupId: UnsavedObjectsPopupComponent;

  listFactory: ListFactory;
  stateUrlCache: StateUrlCache;
  constructor(public busyCursor: BusyCursor,
    public themeService: ThemeService,
    private router: Router) {
    this.listFactory = ListFactory.getInstance();
    this.stateUrlCache = StateUrlCache.getInstance();
    // BusyCursor on routing..
    this.router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.busyCursor.incrementCount();
          break;
        }

        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          setTimeout(() => {
            this.busyCursor.decrementCount();
          });
          break;
        }

        default: {
          break;
        }
      }
    })
  }

  ngAfterViewInit(): void {
    //  this.listFactory.sessionExpiredPopupId = this.sessionExpiredPopupId;
    this.listFactory.globalErrorHandlerPopupId = this.globalExceptionHandlerPopupId;
    this.listFactory.unsavedObjectsPopupId = this.unsavedObjectsPopupId;
  }
}